var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_uid.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_uid.js
// module chunks = 168707334958949